module.exports = __webpack_public_path__ + "img/index-section7-award4.a1a89b7e.png";